
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"title":"~In Zwischenablage kopieren","toast":"~Erfolgreich In Zwischenablage kopiert","toast.error":"~Kopieren in Zwischenablage fehlgeschlagen"},"en":{"title":"~Copy to clipboard","toast":"Successfully copied to clipboard","toast.error":"Copying to clipboard failed"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();